import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, from, fromEvent, merge, Observable, of } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { IViewData } from 'src/app/share/entities/view-model';
import { BasePageComponent, IBasePageOnInitArg } from 'src/app/share/pages/base-page.component';
import { IPageContentViewModel, IPageDataViewModel, IPageViewModel } from 'src/app/share/pages/pages';
import { ShellService } from 'src/app/shell/shell.service';
import { ChauffeurHrService, IChauffeurHrPageData } from './chauffeur-hr.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-chauffeur-hr',
  templateUrl: './chauffeur-hr.component.html',
  styleUrls: ['./chauffeur-hr.component.scss']
})
export class ChauffeurHrComponent extends BasePageComponent implements OnInit {

  /**
   *
   * @param chauffeurHrService
   */
  constructor(protected shellService: ShellService, protected activatedRoute: ActivatedRoute, private chauffeurHrService: ChauffeurHrService, private domSanitizer: DomSanitizer, private router: Router) {
    super(shellService, activatedRoute);
  }

  /**
   *
   */
  iframeLoad(vm: IContentViewModel) {
    window.addEventListener('message', (event) => {
      if (event.data === 'tranq-page-loaded') {
        if (vm?.frameVm)
          vm.frameVm.loading = false;
      }
    });
  }

  /**
   *
   */
  ngOnInit(): void {
    super.onInit((arg: IBasePageOnInitArg) => {

      // user page
      return this.activatedRoute.queryParamMap.pipe(

        // see if going directly to a driver
        map(params => {
          return {
            driverId: params.has('driverId') ? params.get('driverId') : undefined,
            viewType: params.has('viewType') ? params.get('viewType') : undefined
          };
        }),

        // load content VM
        switchMap((ctx) => this.chauffeurHrService.loadPage(ctx.driverId, ctx.viewType)),

        // return page VM
        map((d: IPageDataViewModel) => {
          if (d.workingText || d.errorText)
            return d;

          const ret: IPageDataViewModel = {
            ...d,

            contentVm: this.contentViewModel(arg, d?.data, d?.unauthorized ?? true),

            canAddNew: false, canRefresh: false
          };
          return ret;
        })
      );
    }, { canRefresh: false, canAddNew: false, canGoBack: true });
  }

  /**
   *
   * @param pageVm
   * @param contentVm
   * @param a
   */
  invokeAction(pageVm: IPageViewModel, contentVm: IContentViewModel, a: { code: string, title: string }) {
    if (a.code == 'view-dashboard') {
        this.router.navigate(['chauffeurs', 'hr'], { replaceUrl: true, queryParams: { v: Date.now() } });
    } else if (a.code == 'view-lookup') {
      this.router.navigate(['chauffeurs', 'hr'], { replaceUrl: true, queryParams: { viewType: 'lookup', v: Date.now()  } });
    }
  }

 /**
   *
   * @param arg
   * @param data
   * @param unauthorized
   * @returns
   */
  private contentViewModel(arg: IBasePageOnInitArg, data: IChauffeurHrPageData, unauthorized: boolean): IContentViewModel {
    const vm: IContentViewModel = {
      data: data,

      actions: [
        { code: 'view-dashboard', title: 'Dashboard' },
        { code: 'view-lookup', title: 'Lookup' }
      ],

      frameVm: {
        loading: true,
        unauthorized: unauthorized,
        url: this.domSanitizer.bypassSecurityTrustResourceUrl(data?.config?.url)
      }
    };
    return vm;
  }

}

/**
 *
 */
interface IContentViewModel extends IPageContentViewModel {
  data?: IChauffeurHrPageData;

  actions: { code: string, title: string }[];

  frameVm: {
    loading: boolean;
    unauthorized: boolean;
    url?: SafeResourceUrl;
  };
}


